import classes from "../settings.module.css";
import Button from "../../../components/Button";
import useStyles from "../styles";
import { useMediaQuery } from "@mui/material";
import Table from "../../../components/Table/Table";
// import { TableSearch } from "../../../components/Table/TableActions";
import Badge from "../../../components/Badge";
import { Icon } from "@iconify/react";
import { useState, useEffect, useRef } from "react";
import { toast } from "react-toastify";
import { httprequest } from "../../../data/api";
import PageLoader from "../../../components/PageLoader";
import ViewInvoice from "./ViewInvoice";
import Modal from "../../../components/Modal";
import { useReactToPrint } from "react-to-print";
import payment from "../../../assets/images/payment.png";

const SUBCRIPTION_ENDPOINT = "api/v1/subscription/current";
const SUBCRIPTION_HISTORY = "/api/v1/subscription/payment-history";
const SUBSCRIPTION_INVOICES = "/api/v1/subscription/invoices";

const Princing = ({ next }) => {
  const styles = useStyles();
  const isMobile = useMediaQuery("(max-width:600px)");
  const [currentSubcription, setCurrentSubcription] = useState([]);
  const [subcriptionData, setSubcriptionData] = useState([]);
  const [invoiceData, setInvoiceData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [invoiceModal, setInvoiceModal] = useState(false);
  const invoiceRef = useRef();

  const handlePrint = useReactToPrint({
    content: () => invoiceRef.current,
    pageStyle: `
      @page { size: auto; margin: 5mm; }
      @media print {
        body { -webkit-print-color-adjust: exact; }
      }
    `
  });

  const fetchCurrentSubcription = () => {
    setIsLoading(true);
    httprequest.get(SUBCRIPTION_ENDPOINT)
      .then(res => {
        setCurrentSubcription(res.data.data);
      })
      .catch(err => {
        toast.error(err.response?.data?.message);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const fetchSubcriptionData = () => {
    setIsLoading(true);
    httprequest.get(SUBCRIPTION_HISTORY)
      .then(res => {
        setSubcriptionData(res.data.data);
      })
      .catch(err => {
        toast.error(err.response?.data?.message);
      }).finally(() => {
        setIsLoading(false);
      });
  };

  const fetchSubscriptionInvoices = () => {
    httprequest.get(SUBSCRIPTION_INVOICES)
      .then(res => {
        setInvoiceData(res.data.data);
      })
      .catch(err => {
        toast.error(err.response?.data?.message);
      });
  };

  const rawDate = currentSubcription?.end_date;
  const formattedDate = rawDate
    ? new Date(rawDate).toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric"
    })
    : "NIL";

  const handleInvoiceModal = () => {
    setInvoiceModal(!invoiceModal);
  };

  const columns = [
    {
      name: "Date",
      selector: (row) => (
        <>
          {isMobile && <p className="mobile-styling">Date</p>}
          {row?.created_at.slice(0, 10) || "--/--"}
        </>
      )
    },
    {
      name: "Package",
      selector: (row) => (
        <>
          {isMobile && <p className="mobile-styling">Package</p>}
          {row?.pricing_plan_variant?.name || row?.pricing_plan?.name || "--/--"}
        </>
      )
    },
    {
      name: "Updated At",
      selector: (row) => (
        <>
          {isMobile && <p className="mobile-styling">Period</p>}
          {row?.updated_at?.substring(0, 10) || "--/--"}
        </>
      )
    },
    {
      name: "Amount",
      selector: (row) => (
        <>
          {isMobile && <p className="mobile-styling">Amount</p>}
          {row?.amount || "--/--"}
        </>
      )
    },

    {
      name: "Fee Status",
      cell: (row) => (<Badge status={row?.status} />)
    }
    // {
    //   name: "",
    //   center: "true",
    //   sortable: false,
    //   cell: (row) => (
    //     <div key={row?.id} className="table-action-container">
    //       <button
    //         className="table-action-icon"
    //         onClick={handleInvoiceModal}
    //       >
    //         <Icon icon="ic:outline-print" />
    //       </button>
    //     </div>
    //   )
    // }
  ];

  // Subscription Invoices Columns with detailed amount info
  const invoiceColumns = [
    {
      name: "Invoice Date",
      selector: (row) => (
        <>
          {isMobile && <p className="mobile-styling">Invoice Date</p>}
          {row?.created_at ? new Date(row.created_at).toLocaleDateString() : "--/--"}
        </>
      )
    },
    {
      name: "Plan",
      selector: (row) => (
        <>
          {isMobile && <p className="mobile-styling">Plan</p>}
          {row?.pricing_plan?.name === "Pro" && row?.pricing_plan_variant?.name
            ? `${row.pricing_plan_variant.name}`
            : row?.pricing_plan?.name || "--/--"
          }

        </>
      )
    },
    {
      name: "Billing Period",
      selector: (row) => (
        <>
          {isMobile && <p className="mobile-styling">Billing Period</p>}
          {row?.period_start && row?.period_end
            ? `${new Date(row.period_end).toLocaleDateString()}`
            : "--/--"
          }
        </>
      )
    },
    {
      name: "Amount Due",
      selector: (row) => (
        <>
          {isMobile && <p className="mobile-styling">Amount Due</p>}
          {row?.currency || "NGN"} {(row?.metadata?.amount_due || 0)?.toLocaleString()}
        </>
      )
    },
    {
      name: "Plan Price",
      selector: (row) => (
        <>
          {isMobile && <p className="mobile-styling">Plan Price</p>}
          {row?.currency || "NGN"} {(
            row?.pricing_plan_variant?.price ||
          row?.pricing_plan?.price ||
          0
          )?.toLocaleString()}
        </>
      )
    },
    {
      name: "Status",
      cell: (row) => (<Badge status={row?.status} />)
    },
    {
      name: "",
      center: "true",
      sortable: false,
      cell: (row) => (
        <div key={row?.id} className="table-action-container">
          <button
            className="table-action-icon"
            onClick={() => window.open(`/subscription/invoice/${row?.id}`, "_blank")}

          >
            <Icon icon="fluent:eye-16-regular" />
          </button>
        </div>
      )
    }

  ];
  useEffect(() => {
    fetchCurrentSubcription();
    fetchSubcriptionData();
    fetchSubscriptionInvoices();
  }, []);

  return (
    <div className={classes.pricing}>
      {/* <div className={classes.demodropdown}>
        <div className={classes.demoleft}>
          <p className={classes.demoText}>Demo data clears in</p>
          <h3 className={classes.demoNum}>{profile?.demo_data?.days_remaining || 14 } days</h3>
        </div>
        <Button
          variant="primaryoutline"
          buttonSize="fluid"
          color="btnfontprimary"
          buttonName="Clear"
        />
      </div> */}
      {isLoading ? (
        <div className="page-content" style={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "100px" }}>
          <PageLoader />
        </div>
      ) : (
        <>
          <div className="white_bg page-content">
            <div className={classes.pricingplan}>
              <div>
                <h3>{currentSubcription?.pricing_plan?.name || "Basic Plan"}</h3>
                <span className={styles.active}>Active</span>
              </div>
              {currentSubcription?.pricing_plan?.name === "Pro" ? (
                <p>Pro Type: {currentSubcription?.pricing_plan_variant?.name} || Max Users: {currentSubcription?.pricing_plan_variant?.max_users}</p>
              ) : null}
              <p>{currentSubcription?.currency || "N"}{currentSubcription?.pricing_plan_variant ? currentSubcription?.pricing_plan_variant?.price?.toLocaleString() : currentSubcription?.pricing_plan?.price?.toLocaleString() || 0} Per Month</p>
              {/* <p>{currentSubcription?.currency}{currentSubcription?.price || 0} Per  {
                currentSubcription?.duration === "yearly"
                  ? "Year"
                  : currentSubcription?.duration === "monthly"
                    ? "Month"
                    : currentSubcription?.duration === "quarterly"
                      ? "Quarter"
                      : "Month"
              }
              </p> */}
            </div>
            {currentSubcription?.end_date ?
              <>
                <div className={classes.plan}> <p>Payment Due Date:</p> <p><b>{formattedDate}</b></p></div>
                <Button
                  variant="primary"
                  buttonSize="medium"
                  color="btndefault"
                  buttonName="Change Plan"
                  onClick={next}
                />
              </>
              :
              <div className={classes.nopay}>
                <div>
                  <img src={payment} />
                  <p>No Subcription Due Yet </p>
                </div>
                <Button
                  variant="primary"
                  buttonSize="medium"
                  color="btndefault"
                  buttonName="Change Plan"
                  onClick={next}
                />
              </div>
            }
          </div>
          <div>
            <h3 style={{ textAlign: "left" }}>
              Subscription Invoices
            </h3>
          </div>
          <Table
            data={invoiceData}
            columns={invoiceColumns}
            subHeader={false}
            pagination
          />
          <div style={{ marginTop: "2rem" }}>
            <h3 style={{ textAlign: "left" }}>
              Payment history
            </h3>
          </div>
          <Table
            data={subcriptionData}
            columns={columns}
            subHeader={false}
            pagination
          />
        </>
      )}

      <Modal
        title="View Payment Invoice"
        subtitle={
          <div>
                      View a payment Invoice
          </div>
        }
        modalContent={
          <>
            <div ref={invoiceRef}>
              <ViewInvoice />
            </div>
          </>
        }
        modalFooter={
          <>
            <div className="flex gap-10">
              <Button
                variant="primary"
                buttonName="Print"
                buttonSize="full"
                color="btndefault"
                onClick={handlePrint}
              />
            </div>
          </>
        }
        isopen={invoiceModal}
        closeModal={handleInvoiceModal}
      />
      {/* <ToastContainer /> */}
    </div>
  );
};

export default Princing;
